import { render, staticRenderFns } from "./ReadAccusesList.vue?vue&type=template&id=679ae547"
import script from "./ReadAccusesList.vue?vue&type=script&lang=js"
export * from "./ReadAccusesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports